import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SmoothScroll from "../components/SmoothScroll";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Services from "../components/Services";
import WhyMe from "../components/WhyMe";
import Areas from "../components/Areas";
import Testimonials from "../components/Testimonials";
import FAQ from "../components/FAQ";
import LeadForm from "../components/LeadForm";
import Footer from "../components/Footer";
import MessengerButton from "../components/MessengerButton";

export default function Home() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 400);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);
  return (
    <div className="bg-white">
      <SmoothScroll />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <WhyMe />
        <Areas />
        <Testimonials />
        <FAQ />
        <LeadForm />
      </main>
      <Footer />
      <MessengerButton />
    </div>
  );
}
